import {
   VisitDocumentTemplateType,
   VisitDocumentTemplateUnmarkAsFavoriteCommand,
} from '@dreryk/egabinet-visit-frontend-api';

import { useCqrsCommand } from '@dreryk/command-query-react-common';
import {
   dispatchSnackbarPositiveEvent,
   HeartIcon,
   Link,
   LinkSize,
   LinkVariant,
   Tooltip,
} from '@dreryk/react-components';
import { Choice } from '@dreryk/watermelon';

import { documentTemplateActionTranslationKeys } from '../../../../../../translations';

type DocumentTemplateUnmarkAsFavoriteIconProps = {
   readonly type: VisitDocumentTemplateType;
   readonly printTemplateId: number | undefined;
   readonly onUnarkAsFavorite: VoidFunction;
};

export const DocumentTemplateUnmarkAsFavoriteIcon = (props: DocumentTemplateUnmarkAsFavoriteIconProps): JSX.Element => {
   const { executeAsync: unmarkAsFavorite } = useCqrsCommand<void, void>(
      () => {
         const command = new VisitDocumentTemplateUnmarkAsFavoriteCommand();
         command.type = props.type;
         command.printTemplateId = Choice.withUseDefaultIfNull(props.printTemplateId ?? null);
         return command;
      },
      {
         onSuccess: () => {
            props.onUnarkAsFavorite();
            dispatchSnackbarPositiveEvent(
               documentTemplateActionTranslationKeys.form.table.options.favorite.unmarkAsFavorite.successMessage
            );
         },
      }
   );

   return (
      <Tooltip
         testId={'unmarkAsFavorite'}
         content={documentTemplateActionTranslationKeys.form.table.options.favorite.unmarkAsFavorite.tooltipMessage}
      >
         <Link
            testId={'unmarkAsFavorite'}
            variant={LinkVariant.PRIMARY}
            size={LinkSize.BIG}
            icon={<HeartIcon />}
            onClick={async () => unmarkAsFavorite()}
         />
      </Tooltip>
   );
};
